export const comments_5689018 = {"data":{"data":[],"links":{}}}